"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var OverviewSwitcher = function OverviewSwitcher() {
  var pathName = window.location.pathname;

  if (pathName !== '/overview' && pathName !== '/moderation/overview') {
    return (0, _preact.h)("div", null);
  }

  var linkUrl = pathName === '/overview' ? '/moderation/overview' : '/overview';
  var linkClass = pathName === '/overview' ? 'overview-switcher-old-link-text' : '';
  var linkText = pathName === '/overview' ? 'Switch to old version' : 'Switch to new version';
  return (0, _preact.h)("div", {
    className: "overview-switcher"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(linkUrl),
    className: linkClass,
    onClick: function onClick() {
      return switchLink();
    }
  }, linkText));

  function switchLink() {
    _jsCookie.default.set('old_moderation_overview', '0');

    if (window.location.pathname === '/overview') {
      _jsCookie.default.set('old_moderation_overview', '1');
    }
  }
};

var _default = OverviewSwitcher;
exports.default = _default;